import api from './api';

export interface StockItem {
    id: string;
    itemReferenceCode: string;
    itemName: string;
    outletId: number;
    stock: number;
    bufferStock: number;
    timestamp: number;
    createdAt: string;
    updatedAt: string;
    [key: string]: unknown;
}

export interface StockListData {
    items: StockItem[];
    pagination?: {
        currentPage: number;
        totalPages: number;
        totalItems: number;
        itemsPerPage: number;
    };
}

export interface StockResponse {
    success: boolean;
    message?: string;
    data?: StockListData | StockItem[];
    timestamp?: string;
    statusCode?: number;
}

export interface StockSyncResponse {
    success: boolean;
    message?: string;
    data?: any;
    timestamp?: string;
    statusCode?: number;
}

// Get all stocks with optional pagination
export const getStocks = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
}): Promise<StockResponse> => {
    const response = await api.get('/stocks', { params });
    return response.data;
};

// Get single stock by ID
export const getStockById = async (id: string | number): Promise<{ success: boolean; data?: StockItem }> => {
    const response = await api.get(`/stocks/${id}`);
    return response.data;
};

// Sync stocks from external source
export const syncStocks = async (): Promise<StockSyncResponse> => {
    const response = await api.post('/stocks/sync');
    return response.data;
};

// Get sync status
export const getSyncStatus = async (): Promise<{ success: boolean; data: { isRunning: boolean } }> => {
    const response = await api.get('/stocks/sync/status');
    return response.data;
};
